"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const CancelCircleOutline = _ref => {
  let {
    title = 'Cancel',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 29.344q4.375 0 7.531-3.156t3.156-7.531-3.156-7.531-7.531-3.156-7.531 3.156-3.156 7.531 3.156 7.531 7.531 3.156zM16 5.344q5.5 0 9.406 3.906t3.906 9.406-3.906 9.406-9.406 3.906-9.406-3.906-3.906-9.406 3.906-9.406 9.406-3.906zM19.438 13.344l1.875 1.875-3.438 3.438 3.438 3.438-1.875 1.875-3.438-3.438-3.438 3.438-1.875-1.875 3.438-3.438-3.438-3.438 1.875-1.875 3.438 3.438z"
  }));
};
var _default = exports.default = (0, _ikon.default)(CancelCircleOutline);
CancelCircleOutline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CancelCircleOutline",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Cancel'",
        "computed": false
      },
      "required": false
    }
  }
};